<template>
  <section id="footer" class="w-full bg-white py-3 font-poppins">
    <footer class="container mx-auto px-4 lg:px-10">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <!-- Informações de Contato -->
        <div class="space-y-3 text-purple-900"> <!-- Aumentei o espaçamento entre os itens -->
          <h2 class="text-2xl font-bold mt-9">Fale Conosco </h2>
          <p class="text-[20px] text-gray-700">Entre em contato pelo telefone, e-mail ou redes sociais.</p>

          <!-- Links interativos -->
          <div class="space-y-4"> <!-- Aumentei o espaçamento aqui também -->
            <a
              href="https://wa.me/556199757400"
              target="_blank"
              class="flex items-center gap-2 text-[15px] font-semibold text-purple-900 hover:text-purple-700 transition"
            >
              <img src="@/assets/images/wpp.svg" alt="WhatsApp" class="w-5 h-5" />
              (61) 99975-7400
            </a>
            <a 
              href="mailto:contato@iorbrasilia.com"
              class="flex items-center gap-2 text-[15px] font-semibold text-purple-900 hover:text-purple-700 transition"
            >
              <img src="@/assets/images/gmail.svg" alt="E-mail" class="w-5 h-5" />
              iorbrasilia@gmail.com
            </a>
            <a
              href="https://www.instagram.com/iorbrasilia/"
              target="_blank"
              class="flex items-center gap-2 text-[15px] font-semibold text-purple-900 hover:text-purple-700 transition"
            >
              <img src="@/assets/images/instagram.svg" alt="Instagram" class="w-5 h-5" />
              @iorbrasilia
            </a>
          </div>
        </div>

        <!-- Mapa -->
        <div class="text-purple-900 mt-6">
          <h3 class="text-2xl font-semibold mb-1">Nossa Localização</h3>
          <div class="overflow-hidden rounded-lg shadow-md">
            <iframe
              src="https://www.google.com/maps?q=-16.0186466,-48.0578162&z=17&output=embed"
              class="w-full h-36 sm:h-40 md:h-36 rounded-lg"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      <!-- Crédito -->
      <div class="mt-3 text-center text-gray-600 text-[15px]">
        Desenvolvido por 
        <a 
          href="https://wa.me/5561984770626?text=Olá, Igor! Gostaria de saber mais sobre seus serviços."
          target="_blank"
          class="font-semibold text-purple-900 hover:underline"
        >
          Igor Borges
        </a>.
      </div>
    </footer>
  </section>
</template>

<style scoped>
iframe {
  border: none;
}
</style>
